module.exports = __webpack_public_path__ + "img/Penny-Tote-06.c7ce584e.jpg";